<!-- Screenname:Store Department Tab
Developer Name:Tharuni.
Created date on:1/02/2023
Last Working date on:
Comments and Suggestions:
TS File:StoreService -->
<template>
  <div>
    <b-form ref="formRef" @submit.prevent="IsSubmit">
      <b-row>
        <b-col lg="4" md="4" sm="6" cols="12">
          <div class="field">
            <TextField v-model="dataModelDept.Code" class="DS-Id" type="text" placeholder="" disabled name="Code"
              :label="$t('5000.storeid')" id="Code" />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="6" sm="8" cols="12">
          <div class="field">
            <TextField v-model="dataModelDept.Name" class="DS-Id" type="text" placeholder="" name="Store Name"
              :label="$t('5000.storename')" :rules="{ required: true }" id="Store Name" :required-icon="true"
              case="Capital" :autofocus="true" />
          </div>
        </b-col>
        <b-col lg="4" md="4" sm="8" cols="12">
          <div class="field">
            <MultiSelectDropDown v-model="selectOptionsDept.branchId" :disabled="editDisabled"
              :items="selectOptionsDept.branchOptions" :label="$t('5000.StoreBranch')" :rules="{ required: true }"
              :required-icon="true" id="Store Branch" name="Store Branch" />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="4" md="4" sm="8" cols="12">
          <div class="field">
            <MultiSelectDropDown v-model="selectOptionsDept.MappingbranchId" :disabled="editDisabled"
              :items="selectOptionsDept.MappingbranchOptions" :label="$t('5000.MappingBranch')"
              :rules="{ required: true }" :required-icon="true" id="Branch mapping" name="Branch mapping"
              @update:modelValue="LoadMainDeptStore(), LoadMainSubStore()" />
          </div>
        </b-col>
        <b-col lg="4" md="4" sm="6" cols="12">
          <div class="field">
            <CustomDropDown v-model="managedOptionsDept.managedValue" :items="managedOptionsDept.options"
              @update:modelValue="managedAtOnchangeDept" :disabled="editDisabled" id="managed" name="Managed At"
              :label="$t('5000.inventorymanagedat')" :rules="{ required: true }" :required-icon="true" />
          </div>
        </b-col>
        <b-col lg="4" md="4" sm="6" cols="12" v-if="managedOptionsDept.managedValue == '2'">
          <div class="field">
            <Branch v-model="selectOptionsDept.branchValue" @update:modelValue="handleUpdateValueDept"
              :disabled="editDisabled" name="Branch" id="Branch" />
          </div>
        </b-col>
      </b-row>

      <b-row>
        <b-col lg="4" md="6" sm="8" cols="12">
          <div class="field">
            <MultiSelectDropDown v-model="selectOptionsDept2.storeType" :items="selectOptionsDept2.storeTypeOptions"
              name="Sub/Main Store" :label="$t('5000.choosemainsubStore')" :rules="{ required: true }"
              id="Sub/Main Store" :required-icon="true" />
          </div>
        </b-col>
        <b-col lg="4" md="6" sm="8" cols="12">
          <div class="field">
            <MultiSelectDropDown v-model="selectOptionsDept.deptStoreValue" :items="selectOptionsDept.deptStoreOptions"
              name="Department Store" :label="$t('5000.chooseDeptStore')" :rules="{ required: false }"
              id="Department Store" />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <!-- <b-col lg="4" md="4" sm="4" cols="12">
          <div class="field">
            <label path="Branch">{{ $t("5000.transactionallowed") }}</label>

            <div class="d-flex flex-wrap gap-3">
              <div class="d-flex align-items-center">
                <RadioButton v-model="selectOptionsDept.isTransaction" inputId="ingredient1" name="Yes" value="true" />
                <label for="ingredient1" class="radio-label">{{
                  $t("5000.yes")
                }}</label>
              </div>
              <div class="d-flex align-items-center">
                <RadioButton v-model="selectOptionsDept.isTransaction" inputId="ingredient2" name="No" value="false" />
                <label for="ingredient2" class="radio-label">{{
                  $t("5000.no")
                }}</label>
              </div>
            </div>
          </div>
        </b-col> -->
        <b-col lg="4" md="4" sm="4" cols="12">
          <div class="field">
            <label path="Branch">{{ $t("5000.autoconsumption") }}</label>
            <div class="d-flex flex-wrap gap-3">
              <div class="d-flex align-items-center">
                <RadioButton v-model="selectOptionsDept.isConsumption" inputId="ingredient3" name="Yes" value="true" />
                <label for="ingredient3" class="radio-label">{{
                  $t("5000.yes")
                }}</label>
              </div>
              <div class="d-flex align-items-center">
                <RadioButton v-model="selectOptionsDept.isConsumption" inputId="ingredient4" name="No" value="false" />
                <label for="ingredient4" class="radio-label">{{
                  $t("5000.no")
                }}</label>
              </div>
            </div>
          </div>
        </b-col>

        <b-col lg="4" md="4" sm="4" cols="12">
          <div class="field">
            <label path="Branch">{{ $t("5000.iscamp") }}</label>
            <div class="d-flex flex-wrap gap-3">
              <div class="d-flex align-items-center">
                <RadioButton v-model="selectOptionsDept.IsCamp" inputId="ingredient3" name="Yes" value="true" />
                <label for="ingredient3" class="radio-label">{{
                  $t("5000.yes")
                }}</label>
              </div>
              <div class="d-flex align-items-center">
                <RadioButton v-model="selectOptionsDept.IsCamp" inputId="ingredient4" name="No" value="false" />
                <label for="ingredient4" class="radio-label">{{
                  $t("5000.no")
                }}</label>
              </div>
            </div>
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-col lg="8" md="8" sm="8" cols="12">
          <div class="field">
            <DepartmentStoreDetails :branchId="selectOptionsDept.branchValue" v-model="selectOptionsDept1"
              :items="selectOptionsDept1" />
          </div>
        </b-col>
      </b-row>
      <b-row>
        <b-row class="pe-0">
          <b-col lg="12" md="12" sm="12" cols="12" class="pe-0">
            <div class="field">
              <Description v-model="dataModelDept.Remarks" v-if="loading" name="Description"
                :label="$t('5000.description')" :rules="{ required: false }" id="Description" />
            </div>
          </b-col>
        </b-row>
      </b-row>
      <b-row>
        <n-space justify="end">
          <Footer @cancel="IsClear()" :cancelhide="false" :label="label" :loading="Saveloader" />
        </n-space>
      </b-row>
    </b-form>
  </div>
  <CreateSuccessully :visible="successpop" @ok="closetrigger()" />
  <UpdatedSuccessfully :visible="updatepop" @ok="closetrigger()" />
  <AlreadyExist :visible="alreadyexistpop" @ok="alreadyclosetrigger()" />
</template>

<script lang="ts">
import { defineComponent, ref, onMounted, watch } from "vue";

import Description from "../../../../../../../components/FormComponents/TextArea.vue";
import DepartmentStoreDetails from "../../../../../../../modules/Inventory/components/MastersforInventory/DepartmentStoreDetails.vue";
import Cancel from "../../../../../../../components/GeneralButtons/CancelButtton.vue";
import Save from "../../../../../../../components/GeneralButtons/SaveButton.vue";

import Branch from "../../../../../../../components/FormComponents/BranchDropdown.vue";
import commonservice from "../../../../../Service/StoreService";
import { RouterLink, RouterView, useRouter, useRoute } from "vue-router";
import CustomDropDown from "../../../../../../../components/FormComponents/Dropdown.vue";
import MultiSelectDropDown from "../../../../../../../components/FormComponents/MultiSelectDropdown.vue";
import TextField from "../../../../../../../components/FormComponents/TextInput.vue";
import Footer from "../../../../../../../components/FormComponents/Footer.vue";
import common from "../../../../../Service/CommonService";
import { useForm } from "vee-validate";
import { useI18n } from "vue-i18n";
import CreateSuccessully from "../../../../../../../components/FormComponents/createdsuccessfully.vue";
import UpdatedSuccessfully from "../../../../../../../components/FormComponents/UpdatedSuccessfully.vue";
import AlreadyExist from "../../../../../../../components/FormComponents/AlreadyExist.vue";
import Loader from "../../../../../../../components/FormComponents/Loader.vue";
import moment from "moment";
import CustomTextarea from "../../../../../../../components/FormComponents/TextArea.vue";
import LoginService from "../../../../../../../Services/LoginService";

export default defineComponent({
  components: {
    Description,
    DepartmentStoreDetails,
    Cancel,
    Save,
    Branch,
    CustomDropDown,
    MultiSelectDropDown,
    TextField,
    Footer,
    CreateSuccessully,
    UpdatedSuccessfully,
    AlreadyExist,
    Loader,
    CustomTextarea,
  },
  props: {
    DepartmentStoreRights: {
      type: Object,
      default: {},
    },
  },
  setup(props) {
    //Declarations starts
    let loading = ref(false);
    let Saveloader = ref(false);
    const routes = useRouter();
    const router = useRoute();
    console.log(router.query);
    const storeId = router.query.storeId;
    const storeType = router.query.storeType;
    const childref = ref();
    const { t } = useI18n();
    const label = ref(t("btn.save"));

    watch(
      () => t("btn.save"),
      (newValue) => {
        label.value = newValue;
      }
    );

    let session: any = localStorage.getItem("UsersData");
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }
    let EntityData: any = localStorage.getItem("EntityData");

    session = JSON.parse(session);
    EntityData = JSON.parse(EntityData);

    let HospitalId = Number(session.OrganizationId);
    let BranchId = Number(session.BranchId);
    let UserId = Number(session.UserId);
    let EntityId = Number(EntityData.EntityId);
    let AddressVar = String(session.AddressVar);

    const dataModelDept = ref({
      Code: "",
      Name: "",
      BranchId: BranchId,
      IsBranchId: 0,
      Remarks: "",
      Managedby: 0,
      StoreTypeID: 3,
      CreatedBy: 0,
      ModifiedBy: 0,
      HospitalId: HospitalId,
      CreatedAt: "",
      ModifiedAt: "",
      TransactionBilling: false,
      Id: 0,
      ManagedBy: 0,
      EntityId: 0,
      EntityOperationId: 0,
      Address: "",
      BillingAddress: "",
      IsAutoConsumption: false,
      IsCamp: false,
    });

    const copydataModelDept = JSON.parse(JSON.stringify(dataModelDept.value));
    let mainsubStoreOptionsCopy = [];
    const managedOptionsDept = ref({
      options: [
        { name: "Hospital", value: 1 },
        { name: "Branch", value: 2 },
      ],
      managedValue: ref(),
    });
    let diffArrayDept: any = [];

    const editDisabled = ref(false);

    const selectOptionsDept: any = ref({
      branchValue: ref(),
      isTransaction: "false",
      isConsumption: "false",
      branchId: ref(),
      branchOptions: [],
      deptStoreValue: ref(),
      deptStoreOptions: [],
      MappingbranchId: ref([]),
      MappingbranchOptions: [],
      IsCamp: "false",
    });

    let deptStoreOptionsCopy = [];

    const selectOptionsDept2 = ref({
      storeType: ref(),
      storeTypeOptions: [],
    });
    const copyselectOptionsDept = JSON.parse(
      JSON.stringify(selectOptionsDept.value)
    );
    const selectOptionsDept1 = ref({
      deptValue: ref() ?? "",
      deptOptions: [],
      subDeptValue: ref(),
      subDeptOptions: [],
    });
    const copyselectOptionsDept1 = JSON.parse(
      JSON.stringify(selectOptionsDept1.value)
    );
    const dataMapping = ref({
      departmentId: 0,
      subdepartmentId: 0,
    });
    let diffArray: any = [];
    const { handleSubmit, errors, resetForm, resetField, validate } = useForm();
    const successpop = ref(false);
    const updatepop = ref(false);
    const alreadyexistpop = ref(false);
    let Rights: any = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });

    onMounted(async () => {
      try {
        await LoadBranch();
        debugger;
        Object.keys(props.DepartmentStoreRights).forEach((key) => {
          if (props.DepartmentStoreRights[key])
            Rights.value[key] = props.DepartmentStoreRights[key];
        });
        if (storeType == "3" && storeId != null) {
          label.value = t("btn.update");
          const result1 = await commonservice.GetBranchByStore(storeId);
          console.log(result1);
          let resFields1 = result1["result"].map((str) => parseInt(str));


          // selectOptionsDept.value.branchId = resFields1;

          // Ensure MappingBranchId is an array of numbers
          const BranchIds = Array.isArray(resFields1)
            ? resFields1
            : [];

          // Filter the array to include only valid options
          selectOptionsDept.value.branchId = BranchIds.filter(id =>
            selectOptionsDept.value.branchOptions.some(option => option.value === id)
          );

          const result = await commonservice.getStore(
            storeId,
            Number(router.query.StoreBranchId)
          );
          console.log(result);
          const resFields = result["result"];

          // selectOptionsDept.value.MappingbranchId =
          //   resFields[0].MappingBranchId;

          // Ensure MappingBranchId is an array of numbers
          const mappingBranchIds = Array.isArray(resFields[0].MappingBranchId)
            ? resFields[0].MappingBranchId
            : [];

          // Filter the array to include only valid options
          selectOptionsDept.value.MappingbranchId = mappingBranchIds.filter(id =>
            selectOptionsDept.value.MappingbranchOptions.some(option => option.value === id)
          );


          await LoadMainDeptStore(), await LoadMainSubStore();
          Object.keys(dataModelDept.value).forEach((key) => {
            if (resFields[0][key]) dataModelDept.value[key] = resFields[0][key];
          });
          managedOptionsDept.value.managedValue = resFields[0].ManagedBy;
          // selectOptionsDept.value.isTransaction =
          //   resFields[0].TransactionBilling == true ? "true" : "false";
          selectOptionsDept.value.isConsumption =
            resFields[0].IsAutoConsumption == true ? "true" : "false";

          selectOptionsDept.value.IsCamp =
            resFields[0].IsCamp == true ? "true" : "false";

          let selectedMainSubStore: any = [];
          let selectedDeptStore: any = [];
          debugger;
          for (let i = 0; i < result["result"][0].MainSubStoreId.length; i++) {
            const foundItem: any =
              selectOptionsDept2.value.storeTypeOptions.find(
                (item: any) =>
                  item.Id === Number(result["result"][0].MainSubStoreId[i]) &&
                  item.StoreBranchMapId ===
                  Number(result["result"][0].MainSubStoreBranchMapId[i])
              );
            if (foundItem) {
              selectedMainSubStore.push({
                Id: Number(result["result"][0].MainSubStoreId[i]),
                StoreBranchMapId: foundItem.StoreBranchMapId,
              });
            }
          }
          for (
            let i = 0;
            i < result["result"][0].DepartmentStoreId.length;
            i++
          ) {
            const foundItem: any =
              selectOptionsDept.value.deptStoreOptions.find(
                (item: any) =>
                  item.Id ===
                  Number(result["result"][0].DepartmentStoreId[i]) &&
                  item.StoreBranchMapId ===
                  Number(result["result"][0].DepartmentStoreBranchMapId[i])
              );
            if (foundItem) {
              selectedDeptStore.push({
                Id: Number(result["result"][0].DepartmentStoreId[i]),
                StoreBranchMapId: foundItem.StoreBranchMapId,
              });
            }
          }
          selectOptionsDept2.value.storeType = selectedMainSubStore;
          selectOptionsDept.value.deptStoreValue = selectedDeptStore;

          diffArray = selectOptionsDept2.value.storeType;
          selectOptionsDept.value.branchValue = resFields[0].IsBranchId;

          diffArrayDept = selectOptionsDept.value.deptStoreValue;
          selectOptionsDept1.value.deptValue =
            resFields[0].DepartmentId == 0 ? null : resFields[0].DepartmentId;

          selectOptionsDept1.value.subDeptValue = resFields[0].SubDepartmentId;

          loading.value = true;
        } else {
          loading.value = true;
          GetCode();
        }
      } catch (error) {
        console.error(error);
      }
    });

    function onKeyUp(event: KeyboardEvent) {
      debugger;

      if (event.altKey && event.key == "d") {
        IsSubmit();
      } else if (
        event.key == "Escape" &&
        (successpop.value == true || updatepop.value == true)
      ) {
        closetrigger();
      } else if (event.key == "Escape" && alreadyexistpop.value == true) {
        alreadyclosetrigger();
      }
    }

    //Created Sucessfully Popup-Close
    function closetrigger() {
      routes.push({
        name: "StoreMaster",
      });
    }

    watch(
      props,
      (newValue: any) => {
        debugger;
        console.log("props Changed", newValue.DepartmentStoreRights);
        Object.keys(newValue.DepartmentStoreRights).forEach((key) => {
          if (newValue.DepartmentStoreRights[key])
            Rights.value[key] = newValue.DepartmentStoreRights[key];
        });
        // Rights.value.Create = newValue.DepartmentStoreRights.Create;
        // Rights.value.Update = newValue.DepartmentStoreRights.Update;
        // Rights.value.Read = newValue.DepartmentStoreRights.Read;
        // Rights.value.Delete = newValue.DepartmentStoreRights.Delete;
        // Rights.value.CreateId = newValue.DepartmentStoreRights.CreateId;
        // Rights.value.UpdateId = newValue.DepartmentStoreRights.UpdateId;
        // Rights.value.ReadId = newValue.DepartmentStoreRights.ReadId;
        // Rights.value.DeleteId = newValue.DepartmentStoreRights.DeleteId;
        GetCode();
      },
      { deep: true }
    );

    async function GetCode() {
      debugger;
      let EntityData: any = localStorage.getItem("EntityData");
      EntityData = JSON.parse(EntityData);
      let EntityId = Number(EntityData.EntityId);
      let data = {
        EntityId: EntityId,
        HospitalId: HospitalId,
        BranchId: 0,
        StoreId: 0,
      };
      let result: any = await common.getCodeTemplate(data);
      console.log(result);

      dataModelDept.value.Code = result;
    }

    //Branch Dropdown Change Function
    async function handleUpdateValueDept(value: string, option: any) {
      debugger;
      try {
        dataModelDept.value.IsBranchId = parseInt(value);

        // selectOptionsDept2.value.storeTypeOptions =
        //   mainsubStoreOptionsCopy.filter(
        //     (item: any) =>
        //       item.IsBranchId == selectOptionsDept.value.branchValue ||
        //       item.ManagedBy == 1
        //   );

        if (storeId == null) {
        }
      } catch { }
    }

    //Department Store Submit Click Function

    const IsSubmit = async () => {
      debugger;
      Saveloader.value = true;
      let StoreBranchMapResponse: any;

      // Run validation on all fields
      const results = await validate();

      if (!results.valid) {
        const form = document.querySelector("form");
        const allFormFields: any = form?.querySelectorAll("[id]");
        console.log("All form fields:", allFormFields);

        const errorFields = Object.keys(results.errors);
        const firstErrorField = errorFields[0];
        console.log("First error:", firstErrorField);

        for (const field of allFormFields) {
          console.log("Checking field:", field.id);
          if (field.id === firstErrorField) {
            const component = field.closest(".field");

            if (!component) continue;

            if (component.querySelector(".p-calendar")) {
              const calendar = component.querySelector(".p-calendar input");
              if (calendar) {
                calendar.focus();
                calendar.click();
              }
            } else if (component.querySelector(".p-dropdown")) {
              const dropdown = component.querySelector(".p-dropdown");
              if (dropdown) {
                dropdown.click();
                dropdown.querySelector(".p-dropdown-trigger")?.click();
              }
            } else if (component.querySelector(".p-multiselect")) {
              const multiselect = component.querySelector(".p-multiselect");
              if (multiselect) {
                multiselect.click();
                multiselect.querySelector(".p-multiselect-trigger")?.click();
              }
            } else if (component.querySelector(".p-autocomplete")) {
              const autocomplete = component.querySelector(
                ".p-autocomplete input"
              );
              if (autocomplete) {
                autocomplete.focus();
                autocomplete.click();
              }
            } else {
              const input = component.querySelector("input, textarea");
              if (input) {
                input.focus();
                if (
                  input.type === "text" ||
                  input.type === "email" ||
                  input.tagName.toLowerCase() === "textarea"
                ) {
                  input.select();
                }
              }
            }

            component.scrollIntoView({ behavior: "smooth", block: "center" });
            break;
          }
        }

        Saveloader.value = false;
        return;
      }

      try {
        console.log(dataModelDept.value);
        console.log(selectOptionsDept.value);
        console.log(selectOptionsDept1.value);
        dataModelDept.value.CreatedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        dataModelDept.value.ModifiedAt = moment().format(
          "YYYY-MM-DDTHH:mm:ss.SSSZ"
        );
        dataModelDept.value.BranchId = BranchId;
        dataModelDept.value.HospitalId = HospitalId;
        dataModelDept.value.ModifiedBy = UserId;
        dataModelDept.value.CreatedBy = UserId;

        let EntityData: any = localStorage.getItem("EntityData");
        EntityData = JSON.parse(EntityData);
        let EntityId = Number(EntityData.EntityId);
        dataModelDept.value.EntityId = EntityId;

        // dataModelDept.value.TransactionBilling =
        //   selectOptionsDept.value.isTransaction == "true";

        dataModelDept.value.IsAutoConsumption =
          selectOptionsDept.value.isConsumption == "true";

        dataModelDept.value.IsCamp = selectOptionsDept.value.IsCamp == "true";

        let result: any;
        let msg: String = "";
        let id: any = 0;
        if (storeId != null) {
          dataModelDept.value.EntityOperationId = Rights.value.UpdateId;

          result = await commonservice.updateStore(dataModelDept.value);
          msg = "Updated Successfully";
          id = storeId;
        } else {
          dataModelDept.value.EntityOperationId = Rights.value.CreateId;

          result = await commonservice.insertStore(dataModelDept.value);
          msg = "Inserted Successfully";
          id = result["result"];
        }
        console.log(result);

        let message = result["ErrorInfo"].ErrorCode;

        if (result["result"] == "Already" && message == null) {
          Saveloader.value = false;
          alreadyexistpop.value = true;
        } else if (message == null) {
          //
          //Branch Mapping Insert
          let branchIdValue: any = selectOptionsDept.value.branchId ?? "";
          let dataarr: any = [];
          for (let i = 0; i < branchIdValue.length; i++) {
            let obj: any = {};
            obj["BranchId"] = branchIdValue[i];
            (obj["StoreId"] = parseInt(id)),
              (obj["CreatedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
              (obj["ModifiedAt"] = moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ")),
              (obj["ModifiedBy"] = UserId),
              (obj["CreatedBy"] = UserId);
            dataarr.push(obj);
          }
          StoreBranchMapResponse = await commonservice.insertStoreBranchMapping(
            dataarr
          );
          let messageMap = StoreBranchMapResponse["ErrorInfo"].ErrorCode;

          if (selectOptionsDept.value.deptStoreValue != undefined) {
            let StoreIdbrMapId = StoreBranchMapResponse["result"].filter(
              (item: any) => item.BranchId == BranchId
            );
            let deptStoreValue = selectOptionsDept.value.deptStoreValue ?? "";
            for (let i = 0; i < deptStoreValue.length; i++) {
              let dataModelMapping = {
                StoreId: id,
                StoreMappingId: deptStoreValue[i].Id,
                CreatedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                ModifiedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                ModifiedBy: UserId,
                CreatedBy: UserId,
                StoreBranchMapId: deptStoreValue[i].StoreBranchMapId,
                StoreIdbrMapId: StoreIdbrMapId[0].Id,
              };
              result = await commonservice.insertStoreMapping(dataModelMapping);
            }
          }

          if (selectOptionsDept2.value.storeType != undefined) {
            let storeType = selectOptionsDept2.value.storeType ?? "";
            let StoreIdbrMapId = StoreBranchMapResponse["result"].filter(
              (item: any) => item.BranchId == BranchId
            );
            for (let i = 0; i < storeType.length; i++) {
              let dataModelMapping = {
                StoreId: storeType[i].Id,
                StoreMappingId: id,
                CreatedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                ModifiedAt: moment().format("YYYY-MM-DDTHH:mm:ss.SSSZ"),
                ModifiedBy: UserId,
                CreatedBy: UserId,
                DepartmentId: !selectOptionsDept1.value.deptValue
                  ? 0
                  : selectOptionsDept1.value.deptValue,
                SubDepartmentId: !selectOptionsDept1.value.subDeptValue
                  ? 0
                  : selectOptionsDept1.value.subDeptValue,
                StoreBranchMapId: StoreIdbrMapId[0].Id,
                StoreIdbrMapId: storeType[i].StoreBranchMapId,
              };
              result = await commonservice.insertStoreMapping(dataModelMapping);
            }
          }
          if (messageMap == null) {
            if (storeId != null) {
              Saveloader.value = false;
              updatepop.value = true;
            } else {
              Saveloader.value = false;
              successpop.value = true;
            }
          }
        } else {
          Saveloader.value = false;
          alert("Something went wrong");
        }
      } catch (error) {
        Saveloader.value = false;
        console.log(error);
      }
    };

    async function LoadMainDeptStore() {
      debugger;
      // selectOptionsDept.value.deptStoreOptions.length = 0;
      // selectOptionsDept.value.deptStoreValue = ref();
      try {
        if (selectOptionsDept.value.MappingbranchId.length != 0) {
          let result = await commonservice.ListByBranchId(
            usersData.UserId,
            usersData.OrganizationId,
            usersData.Admin,
            selectOptionsDept.value.MappingbranchId.join(",")
          );

          selectOptionsDept.value.deptStoreOptions = result["result"]
            .filter(
              (i1) =>
                i1.IsActive == true && i1.StoreTypeId == 3 && i1.Id != storeId
            )
            .map((item) => {
              item.name = item.Name + "(" + item.CurrentBranchName + ")";
              item.value = {
                Id: item.Id,
                StoreBranchMapId: item.StoreBranchMapId,
              };
              return item;
            });

          deptStoreOptionsCopy = JSON.parse(
            JSON.stringify(selectOptionsDept.value.deptStoreOptions)
          );
        } else {
          selectOptionsDept.value.deptStoreOptions = [];
        }
      } catch (error) { }
    }

    //Sub Store Multi Select Load function
    async function LoadMainSubStore() {
      debugger;
      // selectOptionsDept2.value.storeTypeOptions.length = 0;
      // selectOptionsDept2.value.storeType = ref();
      try {
        if (selectOptionsDept.value.MappingbranchId.length != 0) {
          let result = await commonservice.ListByBranchId(
            usersData.UserId,
            usersData.OrganizationId,
            usersData.Admin,
            selectOptionsDept.value.MappingbranchId.join(",")
          );

          selectOptionsDept2.value.storeTypeOptions = result["result"]
            .filter((i1) => i1.IsActive == true && i1.StoreTypeId != 3)
            .map((item) => {
              item.name = item.Name + "(" + item.CurrentBranchName + ")";
              item.value = {
                Id: item.Id,
                StoreBranchMapId: item.StoreBranchMapId,
              };
              return item;
            });

          mainsubStoreOptionsCopy = JSON.parse(
            JSON.stringify(selectOptionsDept2.value.storeTypeOptions)
          );
        } else {
          selectOptionsDept2.value.storeTypeOptions = [];
        }
      } catch (error) { }
    }

    function managedAtOnchangeDept() {
      debugger;

      dataModelDept.value.ManagedBy = Number(
        managedOptionsDept.value.managedValue
      );
      selectOptionsDept.value.branchValue = null;

      selectOptionsDept2.value.storeTypeOptions = mainsubStoreOptionsCopy;
      dataModelDept.value.Address =
        dataModelDept.value.ManagedBy == 1 ? AddressVar : "";
    }

    //clear
    function IsClear() {
      Object.assign(dataModelDept.value, copydataModelDept);
      Object.assign(selectOptionsDept.value, copyselectOptionsDept);
      Object.assign(selectOptionsDept1.value, copyselectOptionsDept1);
      managedOptionsDept.value.managedValue = null;

      GetCode();
    }

    function alreadyclosetrigger() {
      debugger;
      alreadyexistpop.value = false;
      dataModelDept.value.Name = "";
    }

    async function LoadBranch() {
      debugger;
      const dataModel = {
        Dml_Indicator: "LBRAN",
        hospital_id: "USH00005",
      };
      // let result = await commonservice.getBranch(session.OrganizationId);

      // selectOptionsDept.value.branchOptions = result["result"]
      //   .map((item) => {
      //     item.name = item.Name;
      //     item.value = item.ID;
      //     return item;
      //   })
      //   .filter((items) => items.OrganizationId == HospitalId);
      // console.log(selectOptionsDept.value);
      const data_response = await LoginService.GetBranchesByUserId(
        usersData.UserId
      );

      selectOptionsDept.value.branchOptions = data_response["result"].map(
        (item) => {
          item.name = item.BranchName;
          item.value = item.BranchId;
          return item;
        }
      );
      selectOptionsDept.value.MappingbranchOptions = data_response[
        "result"
      ].map((item) => {
        item.name = item.BranchName;
        item.value = item.BranchId;
        return item;
      });
    }

    return {
      LoadBranch,
      dataModelDept,
      selectOptionsDept,
      dataMapping,
      //loadSubDepartment,
      handleUpdateValueDept,
      IsSubmit,
      LoadMainSubStore,
      selectOptionsDept1,
      childref,
      loading,
      successpop,
      updatepop,
      closetrigger,
      editDisabled,
      alreadyclosetrigger,
      alreadyexistpop,
      managedAtOnchangeDept,
      managedOptionsDept,
      selectOptionsDept2,
      IsClear,
      label,
      Saveloader,
      Rights,
      LoadMainDeptStore,
    };
  },
});
</script>
